module.exports = __webpack_public_path__ + "img/newsletter-dark.7aadbdd2.svg";